import { OVERALL_DEPARTMENT_ID } from 'shared/constants/department';
import { v5 } from 'uuid';

export const generateSummaryId = ({
  pulseTemplateId,
  pulseId,
  departmentId = OVERALL_DEPARTMENT_ID,
  summaryNamespace,
}: {
  pulseTemplateId: number;
  pulseId: number;
  departmentId?: number;
  summaryNamespace: string;
}) => {
  const key = `${pulseTemplateId}_${pulseId}_${departmentId}`;

  return v5(key, summaryNamespace);
};
